import {
  WSElement,
  WSEmptyState,
  WSLogo
} from "@wingspanhq/fe-component-library";
import { useHistory } from "react-router-dom";
import { openIntercom } from "../../utils/intercom";
import styles from "./index.module.scss";

export const GeneralErrorPage: React.FC = () => {
  const history = useHistory();

  return (
    <WSElement className={styles.root}>
      <WSElement className={styles.header}>
        <WSLogo size="S" />
      </WSElement>

      <WSElement className={styles.content}>
        <WSEmptyState
          hasBorder
          orientation="horizontal"
          type="tasks"
          title="Oops, something went wrong on our end"
          description={
            <>
              If this problem persists, please{" "}
              <a onClick={openIntercom}>contact support</a>
            </>
          }
          actions={{
            buttons: [
              {
                label: "Back to Login",
                onClick: () => {
                  history.replace("/sign-out");
                }
              }
            ]
          }}
        />
      </WSElement>
    </WSElement>
  );
};
